import { render, staticRenderFns } from "./RecoverVehicleListTheft.vue?vue&type=template&id=c36a0310"
import script from "./RecoverVehicleListTheft.vue?vue&type=script&lang=js"
export * from "./RecoverVehicleListTheft.vue?vue&type=script&lang=js"
import style0 from "./RecoverVehicleListTheft.vue?vue&type=style&index=0&id=c36a0310&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports